// extracted by mini-css-extract-plugin
module.exports = {"newsDetailRoot":"index-newsDetailRoot-1PDVo","title":"index-title-3D4VB","content":"index-content-LKqre"};